import "./index.css"


const CopyRight = () => {

return (

    <>
      <div className="bg-container">
            <p>&copy; Copyright 2025 Dream Destination Abroad | All Rights Reserved - Designed by KPS Enterprises</p>
      </div>
    </>
)
}

export default CopyRight